import { Component, ElementRef, OnInit } from '@angular/core';
import { CollectionsService } from '../../../collections/service/collections.service';
import { SearchFilterService } from '../../services/search-filter.service';
import { Subscription } from 'rxjs';
import i18next from 'i18next';
import { CartService } from '../../../cart/services/cart.service';
import { Store } from '@ngrx/store';
import { FilterInterface } from '../../interfaces/filter.interface';
import { ProductInterface } from '../../../products/interfaces/product.interface';
import { first, map, take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { getCurrencySymbol } from '@angular/common';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss'],
})
export class SearchResultsComponent implements OnInit {
  priceActive = false;
  lang!: string;
  articles: ProductInterface[] = [];
  p = 1;
  dataLoaded = this.collectionsService.dataLoaded;
  results: ProductInterface[] = [];
  highestPrice!: number;
  lowestPrice!: number;
  highestVolume!: number;
  lowestVolume!: number;
  lowestDiameter!: number;
  highestDiameter!: number;
  private subscriptions: Subscription = new Subscription();
  filters!: FilterInterface;
  currencySymbol!: string;

  constructor(
    private el: ElementRef,
    public searchFilterService: SearchFilterService,
    public collectionsService: CollectionsService,
    private cartService: CartService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store<{ filter: FilterInterface }>
  ) {
    const priceActiveSub = this.cartService.priceActive$.subscribe((value) => {
      this.priceActive = value;
    });
    this.subscriptions.add(priceActiveSub);
    this.collectionsService.loadDataSub
      .pipe(
        take(1),
        map((item: any) => {
          this.serveData();
        })
      )
      .subscribe();
  }

  ngOnInit(): void {
    console.log('init Filter');
    if (this.dataLoaded) {
      this.serveData();
    }

    const sub = this.store.select('filter').subscribe((data) => {
      this.filters = data;
      console.log('filter init');
    });
    this.subscriptions.add(sub);
  }

  serveData(): void {
    this.currencySymbol = getCurrencySymbol(
      this.collectionsService.currencyCode,
      'narrow'
    );

    this.lang = i18next.language;

    const searchResultsSub$ = this.searchFilterService.searchResults$.subscribe(
      (results) => {
        console.log(results);
        this.results = results;
        this.p = 1;
      }
    );
    this.subscriptions.add(searchResultsSub$);

    this.store
      .select('filter')
      .pipe(first())
      .subscribe((data) => {
        this.filters = data;
        console.log('filter init');
      });

    const activateFilterSub$ =
      this.searchFilterService.activateFilter$.subscribe((active) => {
        if (active) {
          console.log('filter Data');
          this.filterData();
          this.searchFilterService.activateFilter$.next(false);
        }
      });
    this.subscriptions.add(activateFilterSub$);
  }

  pageChange(event: number): void {
    this.p = event;
    const sContainer = document.querySelector('.boxed > .scroll-container');
    if (sContainer) {
      sContainer.scrollTop = 0;
    }
  }

  filterData(): void {
    const sContainer = document.querySelector('.boxed > .scroll-container');
    if (sContainer) {
      sContainer.scrollTop = 0;
    }
    if (this.searchFilterService.searchTerm$.getValue() === '') {
      this.store
        .select('filter')
        .pipe(first())
        .subscribe((data) => {
          this.filters = data;
          console.log('filter set');
          console.log(data);
        });

      let colors = false;
      let shapes = false;
      let sections = false;
      let brands = false;
      let materials = false;
      let prices = false;
      let styles = false;
      let volumes = false;
      let diameters = false;
      let categories = false;

      this.highestPrice = Math.trunc(this.collectionsService.getHighestPrice());
      this.lowestPrice = Math.trunc(this.collectionsService.getLowestPrice());
      this.highestVolume = Math.trunc(
        this.collectionsService.getHighestVolume()
      );
      this.lowestVolume = Math.trunc(
        this.collectionsService.getLowestVolume() + 1
      );
      this.lowestDiameter = Math.trunc(
        this.collectionsService.getLowestDiameter() + 1
      );
      this.highestDiameter = Math.trunc(
        this.collectionsService.getHighestDiameter()
      );

      console.log('filter data');
      this.articles = this.collectionsService.articlesData;

      if (
        this.filters.activeFilterCollection.sections.length > 0 &&
        this.articles
      ) {
        sections = true;
        this.articles = Object.values(this.articles).filter((article) => {
          if (article.filters._default.category_type) {
            console.log(
              'Sections Filter -------------------------------------------------'
            );
            return article.filters._default.category_type.some(
              (section: number) => {
                return this.filters.activeFilterCollection.sections.includes(
                  section.toString()
                );
              }
            );
          } else {
            console.log(
              'No Section -------------------------------------------------'
            );
            // console.log(article);
            return false;
          }
        });
        this.searchFilterService.searchResults$.next(this.articles);
        this.searchFilterService.searchActive$.next(true);
        console.log(this.articles);
      }

      if (
        this.filters.activeFilterCollection.categories.length > 0 &&
        this.articles
      ) {
        categories = true;
        this.articles = Object.values(this.articles).filter((article) => {
          if (article.filters._default.article_type) {
            return article.filters._default.article_type.some(
              (category: number) => {
                return this.filters.activeFilterCollection.categories.includes(
                  category.toString()
                );
              }
            );
          } else {
            // console.log(article);
            return false;
          }
        });
        this.searchFilterService.searchResults$.next(this.articles);
        this.searchFilterService.searchActive$.next(true);
        console.log(this.articles);
      }

      if (
        this.filters.activeFilterCollection.colors.length > 0 &&
        this.articles
      ) {
        colors = true;
        this.articles = Object.values(this.articles).filter((article) => {
          if (article.filters._default.color) {
            console.log(
              'Color Filter -------------------------------------------------'
            );
            return article.filters._default.color.some((color: number) => {
              return this.filters.activeFilterCollection.colors.includes(
                color.toString()
              );
            });
          } else {
            console.log(
              'No Color -------------------------------------------------'
            );
            // console.log(article);
            return false;
          }
        });
        this.searchFilterService.searchResults$.next(this.articles);
        this.searchFilterService.searchActive$.next(true);
        console.log(this.results);
      }

      if (
        this.filters.activeFilterCollection.shape.length > 0 &&
        this.articles
      ) {
        shapes = true;
        this.articles = Object.values(this.articles).filter((article) => {
          if (article.filters._default.shape) {
            console.log(
              'Shape Filter -------------------------------------------------'
            );
            return article.filters._default.shape.some((shape: number) => {
              return this.filters.activeFilterCollection.shape.includes(
                shape.toString()
              );
            });
          } else {
            console.log(
              'No Shape -------------------------------------------------'
            );
            // console.log(article);
            return false;
          }
        });
        this.searchFilterService.searchResults$.next(this.articles);
        this.searchFilterService.searchActive$.next(true);
        console.log(this.results);
      }

      if (this.filters.activeFilterCollection.material && this.articles) {
        materials = true;
        this.articles = Object.values(this.articles).filter((article) => {
          if (article.filters._default.material) {
            console.log(
              'Material Filter -------------------------------------------------'
            );

            return article.filters._default.material.some(
              (material: number) => {
                return (
                  this.filters.activeFilterCollection.material ===
                  material.toString()
                );
              }
            );
          } else {
            console.log(
              'No Material -------------------------------------------------'
            );
            // console.log(article);
            return false;
          }
        });
        this.searchFilterService.searchResults$.next(this.articles);
        this.searchFilterService.searchActive$.next(true);
        console.log(this.results);
      }

      if (this.filters.activeFilterCollection.style && this.articles) {
        styles = true;
        this.articles = Object.values(this.articles).filter((article) => {
          if (article.filters._default.style) {
            console.log(
              'Style Filter -------------------------------------------------'
            );
            return article.filters._default.style.some((style: number) => {
              return (
                this.filters.activeFilterCollection.style === style.toString()
              );
            });
          } else {
            console.log(
              'No Style -------------------------------------------------'
            );
            // console.log(article);
            return false;
          }
        });
        this.searchFilterService.searchResults$.next(this.articles);
        this.searchFilterService.searchActive$.next(true);
        console.log(this.results);
      }

      if (this.filters.activeFilterCollection.brand && this.articles) {
        brands = true;
        this.articles = Object.values(this.articles).filter((article) => {
          if (article.filters._default.brand) {
            console.log(
              'Brand Filter -------------------------------------------------'
            );
            return article.filters._default.brand.some((style: number) => {
              return (
                this.filters.activeFilterCollection.brand === style.toString()
              );
            });
          } else {
            console.log(
              'No Brand -------------------------------------------------'
            );
            // console.log(article);
            return false;
          }
        });
        this.searchFilterService.searchResults$.next(this.articles);
        this.searchFilterService.searchActive$.next(true);
        console.log(this.results);
      }

      console.log(this.highestPrice);
      console.log(this.filters.tags.priceRange.startPrice);
      console.log(this.lowestPrice);
      console.log(this.filters.tags.priceRange.endPrice);

      if (
        (this.filters.tags.priceRange.startPrice !== undefined &&
          this.filters.tags.priceRange.endPrice !== undefined &&
          this.highestPrice !== this.filters.tags.priceRange.endPrice) ||
        (this.lowestPrice !== this.filters.tags.priceRange.startPrice &&
          this.articles)
      ) {
        prices = true;
        this.articles = Object.values(this.articles).filter((article) => {
          if (
            article.price &&
            this.filters.tags.priceRange.startPrice &&
            this.filters.tags.priceRange.endPrice
          ) {
            console.log(article.price);
            console.log(this.filters.tags.priceRange.startPrice);
            console.log(
              article.price >= this.filters.tags.priceRange.startPrice
            );
            console.log(
              'Price Filter -------------------------------------------------'
            );
            return (
              article.price >= this.filters.tags.priceRange.startPrice &&
              article.price <= this.filters.tags.priceRange.endPrice
            );
          } else {
            console.log(
              'No price -------------------------------------------------'
            );
            // console.log(article);
            return false;
          }
        });
        this.searchFilterService.searchResults$.next(this.articles);
        this.searchFilterService.searchActive$.next(true);
        console.log(this.results);
      }

      console.log(this.highestVolume);
      console.log(this.filters.tags.volumeRange.startVolume);
      console.log(this.lowestVolume);
      console.log(this.filters.tags.volumeRange.endVolume);

      if (
        (this.filters.tags.volumeRange.startVolume !== undefined &&
          this.filters.tags.volumeRange.endVolume !== undefined &&
          !Number.isNaN(this.highestVolume) &&
          !Number.isNaN(this.lowestVolume) &&
          this.highestVolume !== this.filters.tags.volumeRange.endVolume) ||
        (this.lowestVolume !== this.filters.tags.volumeRange.startVolume &&
          this.articles)
      ) {
        volumes = true;
        this.articles = Object.values(this.articles).filter((article) => {
          if (
            article.texts.volume &&
            this.filters.tags.volumeRange.startVolume &&
            this.filters.tags.volumeRange.endVolume
          ) {
            console.log(
              'volumeRange Filter -------------------------------------------------'
            );
            return (
              Number(i18next.t(article.texts.volume)) >=
                this.filters.tags.volumeRange.startVolume &&
              Number(i18next.t(article.texts.volume)) <=
                this.filters.tags.volumeRange.endVolume
            );
          } else {
            console.log(
              'No Volume -------------------------------------------------'
            );
            // console.log(article);
            return false;
          }
        });
        this.searchFilterService.searchResults$.next(this.articles);
        this.searchFilterService.searchActive$.next(true);
        console.log(this.results);
      }

      if (
        (this.filters.tags.diameterRange.startDiameter !== undefined &&
          this.filters.tags.diameterRange.endDiameter !== undefined &&
          !Number.isNaN(this.highestDiameter) &&
          !Number.isNaN(this.lowestDiameter) &&
          this.highestDiameter !==
            this.filters.tags.diameterRange.endDiameter) ||
        (this.lowestDiameter !==
          this.filters.tags.diameterRange.startDiameter &&
          this.articles)
      ) {
        diameters = true;
        this.articles = Object.values(this.articles).filter((article) => {
          if (
            article.texts.diameter &&
            this.filters.tags.diameterRange.startDiameter &&
            this.filters.tags.diameterRange.endDiameter
          ) {
            console.log(
              'diameter Filter -------------------------------------------------'
            );
            return (
              Number(i18next.t(article.texts.diameter)) >=
                this.filters.tags.diameterRange.startDiameter &&
              Number(i18next.t(article.texts.diameter)) <=
                this.filters.tags.diameterRange.endDiameter
            );
          } else {
            console.log(
              'No Diameter -------------------------------------------------'
            );
            // console.log(article);
            return false;
          }
        });
        this.searchFilterService.searchResults$.next(this.articles);
        this.searchFilterService.searchActive$.next(true);
        console.log(this.results);
      }
      if (
        !diameters &&
        !shapes &&
        !colors &&
        !materials &&
        !brands &&
        !sections &&
        !volumes &&
        !styles &&
        !prices &&
        !categories
      ) {
        console.log('NO FIlter');
        this.searchFilterService.searchResults$.next(
          Object.values(this.collectionsService.articlesData)
        );
      }
    }
    this.p = 1;
    this.searchFilterService.searchActive$.next(false);
  }

  sortResult(): ProductInterface[] {
    return this.results.sort((a, b) =>
      i18next.t(a.texts.title) > i18next.t(b.texts.title)
        ? 1
        : i18next.t(a.texts.title) === i18next.t(b.texts.title)
        ? 0
        : -1
    );
  }

  ngOnDestroy(): void {
    this.searchFilterService.searchActive$.next(false);
    this.subscriptions.unsubscribe();
  }

  addTocart($event: MouseEvent, product: ProductInterface): void {
    $event.stopImmediatePropagation();
    this.cartService.addToCart(product, product.collection, 1);
  }
}
